const selectGroups = (state) => state.competencyGroups.groups;
const selectIsLoading = (state) => state.competencyGroups.isLoading;

const competencyGroupsSelectors = {
  selectGroups,
  selectIsLoading,
};

export default competencyGroupsSelectors;
